// import one from "../assets/svg/projects/one.svg";
// import two from "../assets/svg/projects/two.svg";
// import three from "../assets/svg/projects/three.svg";
// import four from "../assets/svg/projects/four.svg";
// import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
// import seven from "../assets/svg/projects/seven.svg";
// import eight from "../assets/svg/projects/eight.svg";
import udemy from "../assets/png/myntra.png";
import weather from "../assets/png/weather.png"

export const projectsData = [
  {
    id: 1,
    projectName: "Udemy Clone",
    projectDesc: [
      `A pixel to pixel visual replica of www.udemy.com with debouncing to minimize network requests`,
      [
        "Created Product carousel",
        "Responsive landing page",
        "Major bug fixes",
      ],
    ],
    tags: ["JavaScript", "CSS", "HTML"],
    code: "https://github.com/Ramkrishna1597/udemy-clone",
    demo: "https://aqueous-fortress-78543.herokuapp.com/",
    image:
      "https://user-images.githubusercontent.com/91539305/147107410-e2cf1961-f777-4e33-8a49-586a9a612cb5.gif",
  },
  {
    id: 2,
    projectName: "Udemy Backend Clone",
    projectDesc: [
      "All round Backend integrated clone mimicing the user flow and behavior of Udemy.com",
      ["Configured server and APIs", "Laid out data schema", "Major Bug fixes"],
    ],
    tags: ["MongoDB", "Node JS", "Express"],
    code: "https://github.com/Ashish240399/Udemy_Clone",
    demo: "https://udemy-backend.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/91539305/147107410-e2cf1961-f777-4e33-8a49-586a9a612cb5.gif",
  },
  {
    id: 3,
    projectName: "Myntra Clone",
    projectDesc: [
      "A  clone of Myntra.com with fully a functional cart and product pages",
      [
        "Built all product pages",
        "worked on sorting and filtering",
        "Added functionality to cart",
      ],
    ],
    tags: ["HTML", "JavaScript", "CSS"],
    code: "https://github.com/Luke0912/myntra-app",
    demo: "https://myntra-project.netlify.app/",
    image:udemy
      // "https://raw.githubusercontent.com/Renukote/clone-rodanandfields.com/master/rodan-and-fields-thumbnail.png",
  },
  {
    id: 4,
    projectName: "Weather App",
    projectDesc: [
      "Weather app which shows the climate, wind flow and temperature of all over the world with weeklf forecast.",
      [
        "get api show to ui",
      ],
    ],
    tags: ["HTML", "JavaScript", "CSS"],
    code: "https://github.com/Ramkrishna1597/weather_app",
    demo: "https://ramweatherapp.netlify.app/",
    image:weather
      // "https://raw.githubusercontent.com/Renukote/clone-rodanandfields.com/master/rodan-and-fields-thumbnail.png",
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
